import { PlusCircleOutlined } from '@ant-design/icons'
import { Button, Result } from 'antd'
import React from 'react'
import { useHistory } from 'react-router-dom'

export default ({ orderKey }: any) => {
  const history = useHistory()
  return (
    <Result
      status="success"
      title="Submitted Order Request"
      subTitle={
        <>
          <br />
          Order #{orderKey}
          <br />
          Processing may take ~7 days, please wait.
        </>
      }
      extra={
        <Button type="primary" icon={<PlusCircleOutlined />} onClick={() => history.push('/')}>
          Submit Another
        </Button>
      }
    />
  )
}
